import { render, staticRenderFns } from "./FileInputElementPreview.vue?vue&type=template&id=4fb6a160&scoped=true"
import script from "./FileInputElementPreview.vue?vue&type=script&lang=js"
export * from "./FileInputElementPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6a160",
  null
  
)

export default component.exports